import React from 'react';
import Box from 'components/elements/Box';
import modularScale from 'styles/helpers/modular-scale';
import { NoDataCustomListTitle, ListItemBox } from './styles';
import { ReactComponent as IconCustomList } from 'icons/icon-custom-list.svg';

const NoDataListItem: React.FC = () => {
  return (
    <ListItemBox>
      <Box>
        <IconCustomList />
      </Box>
      <Box display="flex" flexDirection="column" marginLeft={modularScale(1)}>
        <NoDataCustomListTitle>
          Create, share and collaborate with lists. Your own and lists you have
          access to will appear here.
        </NoDataCustomListTitle>
      </Box>
    </ListItemBox>
  );
};

export default NoDataListItem;
